var _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 30.6667,
    rx: 8,
    fill: "url(#paint0_linear_9418_16989)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.5C20 7.10218 20.158 6.72064 20.4393 6.43934C20.7206 6.15804 21.1022 6 21.5 6C21.8978 6 22.2794 6.15804 22.5607 6.43934C22.842 6.72064 23 7.10218 23 7.5V22.5C23 22.8978 22.842 23.2794 22.5607 23.5607C22.2794 23.842 21.8978 24 21.5 24C21.1022 24 20.7206 23.842 20.4393 23.5607C20.158 23.2794 20 22.8978 20 22.5V7.5ZM8 7.5C8 7.10218 8.15804 6.72064 8.43934 6.43934C8.72064 6.15804 9.10218 6 9.5 6C9.89782 6 10.2794 6.15804 10.5607 6.43934C10.842 6.72064 11 7.10218 11 7.5V22.5C11 22.8978 10.842 23.2794 10.5607 23.5607C10.2794 23.842 9.89782 24 9.5 24C9.10218 24 8.72064 23.842 8.43934 23.5607C8.15804 23.2794 8 22.8978 8 22.5V7.5Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9418_16989",
    x1: 15.5,
    y1: 30.6667,
    x2: 15.5,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006AB3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006AB3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/Pause.d9a1eb46ee3b9d58b7e406a0cfab103b.svg";
export { ForwardRef as ReactComponent };